export const URL_DATA_STUDIO_DASHBOARD =
  'https://datastudio.google.com/embed/reporting/c36ab556-89d9-4f18-bd29-68a62bf93537/page/p_e1rjb5w1yc';

export const URL_UI_AVATARS = 'https://ui-avatars.com/api/?name=';
